/**
 * Created by filatov on 12.08.2015.
 */
import Ext from 'Ext'
import _ from 'underscore'
import SelectorPanelWithApplyButtonHelper from './selectorControls/at_selector_panel_with_apply_button_object'
import SharedUserButtonMenu from './selectorControls/at_shared_user_button_menu'
import HierarchySelectorDropdownButton from './selectorControls/at_hierarchy_selector_dropdown_button'
import messageResource from '../messageResource'
import User from '../store/User'
import Group from '../store/Group'
import TwoLevelSelection from './selectorControls/two_level_selection'
import ReportsSelectorUsersPanel from '../reports/at_reports_selector_users_panel'
import GenericAdditionalCheckboxExtension from './selectorControls/at_selector_panel_generic_additional_checkbox_extension'

export default function ReportUserSelectorButton()
{}

ReportUserSelectorButton.prototype.init = function ( config )
{
    const self = this;
    this.containerId = config.selectorId;

    this.predefinedUserSelection = {};
    const reportConfigUserSelection = config.userSelection;

    this.settedWithPredefinedValues = !!reportConfigUserSelection;
    this.predefinedUserSelection.selectedUsers = reportConfigUserSelection &&  reportConfigUserSelection.selectedUsers ? reportConfigUserSelection.selectedUsers : [];
    this.predefinedUserSelection.selectedGroups = reportConfigUserSelection && reportConfigUserSelection.selectedGroups ? reportConfigUserSelection.selectedGroups : [];
    this.predefinedUserSelection.allUsers = reportConfigUserSelection ? !!reportConfigUserSelection.allUsers : true;
    this.predefinedUserSelection.showDisabled = reportConfigUserSelection ?  !!reportConfigUserSelection.showDisabled : true;
    this.predefinedUserSelection.includeUsersWithoutData = reportConfigUserSelection ? !!reportConfigUserSelection.includeUsersWithoutData : false;
    this.predefinedUserSelection.groupType = reportConfigUserSelection ? reportConfigUserSelection.groupType : null;
    this.predefinedUserSelection.includeUserTeamOnly = reportConfigUserSelection ? reportConfigUserSelection.includeUserTeamOnly : false

    let params = config.report_name ? {collapsedCookiesKey: config.report_name }:{};
    const panelConstructor = !config.specificConstructorPanel ? ReportsSelectorUsersPanel : config.specificConstructorPanel;
    if ( config.withApplyButton )
        Ext.apply( params, SelectorPanelWithApplyButtonHelper.getApplyButtonExtension( panelConstructor ) );

    this.needAdditionalCheckbox = config.needAdditionalCheckbox;
    this.includeUsersWithoutDataDefaultValue = _.isUndefined(config.includeUsersWithoutDataDefaultValue) ? false : config.includeUsersWithoutDataDefaultValue;

    let selectorPanelHeight = 450;
    if( this.needAdditionalCheckbox ) {
        Ext.apply(params, new GenericAdditionalCheckboxExtension(panelConstructor, config.additionalCheckboxLabel));
        selectorPanelHeight += 20;
    }

    params = {...params, allUsersAvailable: config.allUsersAvailable}

    this.panel = new panelConstructor(params);
    this.panel.setPredefinedState(this.convertPredefinedStateFromSelection(this.predefinedUserSelection));

    this.userSelectorMenu = new SharedUserButtonMenu( {panel: self.panel} );
    this._createUserButton(this.containerId, this.userSelectorMenu, selectorPanelHeight, config);
    return this;
};

ReportUserSelectorButton.prototype._createUserButton = function(containerId, userSelectorMenu, selectorPanelHeight, config)
{
    const self = this;
    this.chooseUserButton = new HierarchySelectorDropdownButton({
        labelCls: "hierarchySelectorButton",
        renderTo: containerId,
        menu: userSelectorMenu,
        selectorPanelHeight: selectorPanelHeight
    });

    this.wasChanged = false;
    this.chooseUserButton.setMenuHideCallback(function()
                                              {
                                                  if (config.changeCallback && self.wasChanged)
                                                      self.wasChanged = false;
                                                  config.changeCallback();
                                              });
    this.chooseUserButton.setText(messageResource.getMessage("users_selector.reports.loading"));
    this.chooseUserButton.setEnabled(false);
};

ReportUserSelectorButton.prototype.updateButton = function() {
    this.panel.updateAllSelectedLabel()
    this.chooseUserButton.updateButton()
}

ReportUserSelectorButton.prototype.getButton = function() {
    return this.chooseUserButton
}

ReportUserSelectorButton.prototype.setInitialValueFromCurrent = function(){
    this.panel.setInitialValueFromCurrent();
};

ReportUserSelectorButton.prototype.updateSelector = function(users, userGroups, timeZoneGroups, manageableUsersIds, showTeamOnly) {
    const convertedUserGroups = (userGroups == null) ? null : this.convertUserGroupBeansToJsGroups(userGroups);
    const convertedTimeZoneGroups = (timeZoneGroups == null) ? null : this.convertGroupBeansToJsGroups(timeZoneGroups);
    this.initializeData(
        userGroups != null,
        timeZoneGroups != null,
        this.convertUserInfoToJsUsers(users),
        manageableUsersIds,
        convertedUserGroups,
        convertedTimeZoneGroups,
        showTeamOnly
    )
};

ReportUserSelectorButton.prototype.initializeData = function(userGroupsEnabled, timeZoneGroupsEnabled, users, manageableUsersIds, userGroups, timeZoneGroups, showTeamOnly){
    this.panelWasConstructing = true;
    this.panel.initialize({
        userGroupsEnabled: userGroupsEnabled,
        timeZoneGroupsEnabled: timeZoneGroupsEnabled,
        users: users,
        manageableUsersIds: manageableUsersIds,
        userGroups: userGroups,
        timeZoneGroups: timeZoneGroups,
        showTeamOnly: showTeamOnly,
    });
    this.chooseUserButton.setEnabled(true);
};

ReportUserSelectorButton.prototype.getSelection = function(){
    if(this.panelWasConstructing)
    {
            const result = {};
            result.allUsers = !this.panel.isCustomOptionSelected();
            const selection = this.panel.getSelection();
            result.selectedGroups = selection.getFirstLevel();
            result.selectedUsers = selection.getSecondLevel();
            result.showDisabled = this.panel.getShowInactive();
            result.includeUsersWithoutData = this.needAdditionalCheckbox ? this.panel.getAdditionalCheckboxValue() : 
                                             (result.allUsers ? false : this.includeUsersWithoutDataDefaultValue);
            result.groupType = this.panel.getGroupType();
            result.includeUserTeamOnly = !!this.panel.showTeamOnly
            return result;
    }
    return this.predefinedUserSelection;
};

ReportUserSelectorButton.prototype.setSelection = function(userSelection){
    const predefinedState = this.convertPredefinedStateFromSelection( userSelection );
    this.panel.setPredefinedState( predefinedState );
    if(this.panelWasConstructing)
    {
        this.panel.loadState( predefinedState );
    }
};

ReportUserSelectorButton.prototype.convertUserInfoToJsUsers = function ( userbeans )
{
    const users = [];
    for( let i = 0; i < userbeans.length; ++i )
    {
        const u = userbeans[i];
        users.push(new User(u.id, u.firstName, u.lastName, u.middleName, u.username, u.enabled, undefined, u.userGroupId, u.timeZoneGroupId))
    }
    return users;
};

ReportUserSelectorButton.prototype.convertUserGroupBeansToJsGroups = function (groupbeans)
{
    const groups = this.convertGroupBeansToJsGroups(groupbeans);
    groups.unshift(new Group(window.SystemSettings.usersWithoutGroupId, messageResource.getMessage('common.users_without_group')));
    return groups;
};

ReportUserSelectorButton.prototype.convertGroupBeansToJsGroups = function (groupbeans)
{
    const groups = [];
    for (let i = 0; i < groupbeans.length; ++i)
    {
        const g = groupbeans[i];
        groups.push(new Group(g.id, g.name));
    }
    return groups;
};

//need invoke when drop state on initial
ReportUserSelectorButton.prototype.resetValue = function(){
    if(this.panel.isAlreadyShown())
    {
        this.panel.resetState( true );
    }
};

ReportUserSelectorButton.prototype.validateIsUserSelected = function(){
    return  ( this.settedWithPredefinedValues || this.panel.isAlreadyShown() ) ? this.panel.validateIsUsersSelected() :
            this.predefinedUserSelection.allUsers ||
            this.predefinedUserSelection.selectedUsers != [] ||
            this.predefinedUserSelection.selectedGroups != []
};

ReportUserSelectorButton.prototype.setWasChanged = function(){
    this.wasChanged = true;
};

ReportUserSelectorButton.prototype.convertPredefinedStateFromSelection = function(selection){
    return {
        selection: selection.allUsers ? TwoLevelSelection.emptySelection() : new TwoLevelSelection( selection.selectedGroups, selection.selectedUsers ),
        optionValue: selection.allUsers,
        showInactive: selection.showDisabled,
        additionalCheckBoxValue: selection.includeUsersWithoutData,
        groupType: selection.groupType
    }
};

ReportUserSelectorButton.prototype.isStateChanged = function() {
    return this.panel.isStateChanged();
};


// WEBPACK FOOTER //
// ./web/js/controls/ReportUserSelectorButton.js